import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment-timezone';
import { AxlPanel, AxlButton, AxlModal, Colors } from 'axl-reactjs-ui';

// Utils

// Styles
import styles from './styles';

export default class ShipmentPickupInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      arrow: true,
      showPanel: this.props.isOpen
    }
  }

  componentDidMount() {
    if(this.props.arrow !== undefined) {
      this.setState({arrow: this.props.arrow});
    }
  }

  render() {
    const { arrow } = this.state;
    const { pickup, dropoff, shipment, item, isEdit } = this.props;
    const COMPLETED = ['SUCCEEDED', 'FAILED'];
    const pickupStatus = (pickup && pickup.status) ? pickup.status : null
    const statusColor = pickupStatus ? styles.Status[pickupStatus] : styles.Status['DEFAULT'];
    const dtFormat = moment(shipment.dropoff_latest_ts).isBefore(moment()) ? 'MM/DD hh:mm A z' : 'hh:mm A z'

    return  <AxlPanel style={styles.panelContainer}>
      <div style={styles.panelHeader}>
        <div style={styles.panelHeaderTitle}>{`Pickup Info:`}</div>
        <div style={styles.panelHeaderRight}>
          <div style={styles.wrapHeaderEdit}>
            <div style={{...styles.panelHeaderStatus, ...{color: statusColor}}}><span>{pickupStatus} { pickup && pickup.actual_departure_ts && <span> @ {moment.tz(pickup.actual_departure_ts, moment.tz.guess()).format(dtFormat)}</span> }</span></div>
            <div style={styles.panelHeaderButton}><AxlButton tiny bg={`white`} onClick={this.props.openForm('PickupInfo')}>{`Edit`}</AxlButton></div>
          </div>
          {arrow && <div style={styles.panelHeaderArrow} onClick={() => this.setState({showPanel: !this.state.showPanel})}>
            <i className={!this.state.showPanel ? 'fa fa-angle-down' : 'fa fa-angle-up'} />
          </div>}
        </div>
      </div>
      {this.state.showPanel && <AxlPanel.Row style={styles.panelContent}>
        <AxlPanel.Col flex={1}>
          <AxlPanel.Row style={styles.row}>
            <AxlPanel.Col>
              <div style={styles.text}>{shipment.pickup_address.street}</div>
              <div style={styles.text}>{shipment.pickup_address.street2}</div>
              <div style={styles.text}>{shipment.pickup_address.city}, {shipment.pickup_address.state} {shipment.pickup_address.zipcode}</div>
            </AxlPanel.Col>
            { shipment.pickup_note && <AxlPanel.Col>
              <div style={styles.noteLabel}>{`NOTES`}</div>
              <div style={styles.noteContent}>{shipment.pickup_note}</div>
            </AxlPanel.Col>}
          </AxlPanel.Row>
          {shipment.pickup_earliest_ts && shipment.pickup_latest_ts && (
            <AxlPanel.Row>
              <AxlPanel.Col>
                <AxlPanel.Row style={styles.timewindow}>
                  <AxlPanel.Col flex={1}>
                    <div style={styles.timeLabel}>{`Time Window:`}</div>
                    <div>{moment.tz(shipment.pickup_earliest_ts, moment.tz.guess()).format(dtFormat)} - {moment.tz(shipment.pickup_latest_ts, moment.tz.guess()).format(dtFormat)}</div>
                  </AxlPanel.Col>
                </AxlPanel.Row>
              </AxlPanel.Col>
            </AxlPanel.Row>
          )}
          <AxlPanel.Row>
            <AxlPanel.Col flex={1}>
              <div style={styles.dropoffRemarkContainer}>
                <div style={{...styles.dropoffRemarkHeader,...{color: statusColor}}}>
                  <div style={styles.dropoffRemarkHeaderStatus}>{`PICKUP REMARK`}</div>
                  {pickupStatus && <div style={styles.dropoffRemarkHeaderTime}>{_.capitalize(pickupStatus)} { pickup && pickup.actual_departure_ts && <span> @ {moment.tz(pickup.actual_departure_ts, moment.tz.guess()).format(dtFormat)}</span>}</div>}
                </div>
                <div style={{...styles.dropoffRemarkContent,...{borderColor: statusColor}}}>
                  <div style={styles.dropoffRemarkContentText}>{(pickup && pickup.remark) ? pickup.remark : '-'}</div>
                </div>
              </div>
            </AxlPanel.Col>
          </AxlPanel.Row>
        </AxlPanel.Col>
      </AxlPanel.Row>}
    </AxlPanel>
  }
}
